// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1dOCV","head":"ProcedureTableInfo_head__3AtR7"};